'use strict';

/**
 * Module definition file
 *
 * All services, controllers, and directives are registered with angular here
 *
 * Bower dependencies should NOT be required here. They should be required in tests/lib.js.
 */

require('js-data');
require('js-data-angular');

var app = angular.module('saturn.data', [
  'js-data'
]);

var ResourceHelper = require('./ResourceHelper');

app.config(['DSHttpAdapterProvider', 'DSProvider', function (DSHttpAdapterProvider, DSProvider) {

  DSHttpAdapterProvider.defaults.log = false;
  DSProvider.defaults.debug = false;

  DSHttpAdapterProvider.defaults.deserialize = function (resource, data) {
    // By the design of our endpoints, the actual resource data comes wrapped in
    // an object with a property 'data', and additional properties in 'meta'.
    return data.data.data ? data.data.data : data.data;
  };

}]);

app.service('ResourceHelper', [
  'DS',
  ResourceHelper
]);



// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/data/src/index.js